import Slide1 from '../assets/img/carousel/slide1.jpg';
import Slide4 from '../assets/img/carousel/slide4.jpg';

import AboutMeImg from '../assets/img/retrato/aboutMe.jpg'

/** Main Carousel Data */
export const mainCarouselData = [
  {
    id: 1,
    title: 'Jessica Avilés',
    // desc: 'Garantizamos hasta un 15% de retorno por tu inversión',
    imgMe: AboutMeImg,
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1689974575/Projects/unne/img/hero/remate3.jpg',
  },
  {
    id: 2,
    title: 'Jessica Avilés',
    // desc: 'En Alianza con los Bancos más importantes del país',
    imgMe: AboutMeImg,
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1689975271/Projects/unne/img/hero/financiamiento2.jpg',
  },
  {
    id: 3,
    title: 'Jessica Avilés',
    // title: '¡Simplifica tus trámites legales con nuestros abogados inmobiliarios!',
    // desc: 'Nos encargamos de todo el proceso de la postventa de tu propiedad',
    imgMe: AboutMeImg,
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1689975597/Projects/unne/img/hero/tramite2.jpg',
  },
  {
    id: 4,
    title: 'Jessica Avilés',
    // title: '¡Deja la venta de tu propiedad en mano de expertos!',
    // desc: 'Somos la corredora más grande del país, con más de 6000 publicaciones activas',
    imgMe: AboutMeImg,
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1689974937/Projects/unne/img/hero/venta.jpg',
  },
];



/** Tabs search by Property Data */
export const webServicesTabs = ['venta', 'arriendo ', 'arriendo_temporal'];




